<template>
  <section class="ct-richtext-feed">
    <div class="ct-richtext-feed__container container">
      <div class="content-type__content">
        <div
          v-if="slice?.Settings?.Title"
          class="content-type__heading heading heading--2"
        >
          {{ slice.Settings.Title }}
        </div>

        <p
          v-if="slice?.Settings?.Description"
          class="content-type__description"
        >
          {{ slice.Settings.Description }}
        </p>

        <div
          v-if="slice?.Copy?.Richtexts?.length"
          class="ct-richtext-feed__grid"
        >
          <div
            v-for="data in slice.Copy.Richtexts"
            :key="data"
            class="ct-richtext-feed__richtext"
            :style="`color: ${data.Color || 'inherit'}`"
          >
            <StrapiBlocksText
              :nodes="data.Richtext"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
defineProps({
  slice: {
    type: Object,
    required: true,
  },
  index: {
    type: Number,
    required: true,
  },
  slices: {
    type: Array,
    required: true,
  },
})
</script>

<style>
@import url("~layers/app/components/Slices/RichtextFeed.css");
</style>
